import requestJson from '@/utils/requestJson'

// 保存用户登录信息
export function userLogin (data) {
  return requestJson({
    url: '/login/userGoLogin',
    method: 'POST',
    data: data // 它是直接把参数转成JSON放在BODY中
  })
}

// 获取会议列表
export function QueryActives () {
  return requestJson({
    url: `/active/user/queryActives`,
    method: 'GET'
  })
}

// 查找会议详情
export function queryByIdActive (id) {
  return requestJson({
    url: `/active/user/queryByIdActive?id=${id}`,
    method: 'get'
  })
}

// 用户表单填写
export function addUserForm (data) {
  return requestJson({
    url: '/userForm/user/addUserForm',
    method: 'POST',
    data: data // 它是直接把参数转成JSON放在BODY中
  })
}

// 一个用户只能填写一次,查看用户是否报名
export function queryByIdUserForm (openId, activeId) {
  return requestJson({
    url: `/userForm/user/queryByIdUserForm?openId=${openId}&activeId=${activeId}`,
    method: 'GET'
  })
}

// 表单详情
export function queryByIdUserActive (formId) {
  return requestJson({
    url: `/active/user/queryByIdActive?id=${formId}`,
    method: 'GET'
  })
}

export function authorize (openId) {
  return requestJson({
    url: `/authorize?openId=${openId}`,
    method: 'POST'
  })
}

export function prizeLifeSciences (data) {
  return requestJson({
    url: `/prize_life_sciences`,
    method: 'POST',
    data
  })
}
